import React, { useState } from 'react';
import { Box, IconButton, makeStyles, Typography } from '@material-ui/core';

import Map from 'tags/Map';
import { ReactComponent as MapIcon } from 'assets/icons/pin-icon.svg';

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  button: {
    height: '54px',
    border: 'none',
    borderRadius: '100vh',
    backgroundColor: palette.secondary.light,
    padding: '12px 5px 12px 20px',
    outline: 'none',
    marginRight: '10px',
    '& svg': {
      verticalAlign: 'middle',
      margin: '-5px 10px 0 10px',
    },
  },

  dropdown: {
    position: 'absolute',
    width: '130px',
    top: '35px',
    left: '15px',
    backgroundColor: palette.secondary.light,
    listStyle: 'none',
    padding: 0,
    zIndex: 1,
    '& li': {
      padding: '5px 10px',
      cursor: 'pointer',
    },
  },
}));

const MapSearch = () => {
  const classes = useStyles();

  const [showMenu, setShowMenu] = useState(false);
  const [showMap, setShowMap] = useState('');

  const handleMap = (type: string) => {
    setShowMenu(false);
    setShowMap(type);
  };

  return (
    <Box position="relative" style={{ minWidth: '165px' }}>
      <IconButton className={classes.button} onClick={() => setShowMenu(!showMenu)}>
        <Typography>
          Map Search
          <MapIcon />
        </Typography>
      </IconButton>
      {showMenu && (
        <ul className={classes.dropdown}>
          <li onClick={() => handleMap('London')}>
            <Typography>London Map</Typography>
          </li>
          <li onClick={() => handleMap('UK')}>
            <Typography>UK Map</Typography>
          </li>
        </ul>
      )}
      {!!showMap.length && <Map type={showMap} action={() => setShowMap('')} />}
    </Box>
  );
};

export default MapSearch;
